var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("BIENVENIDO A SIDRA")]),_c('p',[(_vm.authNeeded)?_c('v-btn',{on:{"click":_vm.toAuth}},[_vm._v("Entrar a SIDRA")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }